// Button icon matches service page; menu icons match operator-ui learn-button (service page).
export const ICON_WIDTH = 16
export const MENU_ICON_SIZE = 20

export const LEARN_BUTTON_TEXT = 'Learn'
export const HELP_BUTTON_TEXT = 'Help Articles'
export const WHATS_NEW_BUTTON_TEXT = 'What\'s New'
